<div class="flex align-items-center justify-content-between gap-3 mb-3">
    <div>
        <div class="flex align-items-center gap-1">
            <h5 class="m-0">Respuesta automática</h5>
            <button
                pButton
                type="button"
                icon="pi pi-question-circle"
                class="p-button-text p-button-rounded p-button-sm p-button-secondary"
                pTooltip="Cómo funciona"
                tooltipPosition="top"
                aria-label="Cómo funciona la respuesta automática"
                (click)="ayudaVisible = true"
            ></button>
        </div>
        <small class="text-500">
            Cuando el cliente toca un botón de esta plantilla, el flujo le sigue la conversación hasta cerrarla o pasarla a una persona.
        </small>
    </div>
    <p-inputSwitch
        [ngModel]="activo"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="bloqueado || !plantillaTieneBotones"
        (ngModelChange)="onToggleActivo($event)"
    ></p-inputSwitch>
</div>

<app-flujo-ayuda [(visible)]="ayudaVisible"></app-flujo-ayuda>

<p-message
    *ngIf="bloqueado"
    severity="warn"
    [text]="motivoBloqueo"
    styleClass="w-full mb-3"
></p-message>

<p-message
    *ngIf="!plantillaTieneBotones && !bloqueado"
    severity="info"
    text="Agregá al menos un botón de respuesta rápida para poder armar el flujo: esos botones son el primer paso."
    styleClass="w-full mb-3"
></p-message>

<div *ngIf="activo && versionForm" [formGroup]="versionForm">

    <app-flujo-validacion-panel
        *ngIf="hallazgos.length"
        [valido]="false"
        [hallazgos]="hallazgos"
        [validando]="false"
    ></app-flujo-validacion-panel>

    <div class="p-3 mb-3 border-round surface-100" *ngIf="pendientes.length">
        <div class="font-semibold mb-3">
            Falta {{ pendientes.length }} {{ pendientes.length === 1 ? 'cosa' : 'cosas' }} para terminar
        </div>

        <div *ngFor="let pendiente of pendientes; trackBy: trackPendiente" class="pb-3 mb-3 border-bottom-1 surface-border">
            <div class="mb-2">{{ pendiente.titulo }}</div>
            <small class="text-500 block mb-2" *ngIf="pendiente.detalle">{{ pendiente.detalle }}</small>

            <div class="flex gap-2 flex-wrap align-items-center"
                *ngIf="pendiente.codigo === PENDIENTE.BOTON_SIN_DESTINO && pendiente.indiceOpcion !== null
                    || pendiente.codigo === PENDIENTE.MENSAJE_SIN_SIGUIENTE">
                <p-dropdown
                    [options]="tiposParaResolver"
                    [ngModel]="null"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="bloqueado"
                    placeholder="Crear la respuesta…"
                    styleClass="w-14rem"
                    appendTo="body"
                    (onChange)="resolverCreando(pendiente, $event.value)"
                ></p-dropdown>

                <span class="text-500 text-sm">o</span>

                <p-dropdown
                    [options]="nodosDisponibles"
                    optionLabel="label"
                    optionValue="id"
                    [ngModel]="null"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="bloqueado"
                    placeholder="Llevar a un paso que ya existe…"
                    styleClass="w-18rem"
                    appendTo="body"
                    (onChange)="resolverConExistente(pendiente, $event.value)"
                ></p-dropdown>
            </div>

            <button
                *ngIf="pendiente.codigo === PENDIENTE.PASO_SIN_TEXTO
                    || (pendiente.codigo === PENDIENTE.BOTON_SIN_DESTINO && pendiente.indiceOpcion === null)"
                pButton
                type="button"
                label="Abrir"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-sm"
                [disabled]="bloqueado"
                (click)="abrirPendiente(pendiente)"
            ></button>
        </div>
    </div>

    <p-message
        *ngIf="circuitoCerrado"
        severity="success"
        text="Listo. Todos los caminos terminan y hay salida a una persona."
        styleClass="w-full mb-3"
    ></p-message>

    <div class="flex justify-content-between align-items-center mb-3">
        <small class="text-500">El mapa de lo que armaste</small>
        <button
            pButton
            type="button"
            label="Agregar paso"
            icon="pi pi-plus"
            class="p-button-outlined p-button-sm"
            [disabled]="bloqueado"
            (click)="agregarNodo()"
        ></button>
    </div>

    <app-flujo-nodo-lista
        [nodosFormArray]="$any(versionForm.get('nodos'))"
        [nodoInicialId]="ID_NODO_INICIAL"
        [disparadores]="disparadores"
        [nodosSinFinal]="nodosSinFinal"
        [nodosInalcanzables]="nodosInalcanzables"
        (editarNodo)="editarNodo($event)"
        (eliminarNodo)="eliminarNodo($event)"
    ></app-flujo-nodo-lista>

    <app-flujo-nodo-editor
        [(visible)]="sidebarVisible"
        [nodoForm]="nodoFormSeleccionado"
        [nodosDisponibles]="nodosDisponibles"
        [esInicial]="nodoSeleccionadoEsInicial"
    ></app-flujo-nodo-editor>
</div>
